module.exports = __webpack_public_path__ + "static/media/prv5.c9bf08a7.jpg";